var items = {
  "block.minecraft.air": "aero",
  "block.minecraft.stone": "petro",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "polisita granito",
  "block.minecraft.diorite": "diorito",
  "block.minecraft.polished_diorite": "polisita diorito",
  "block.minecraft.andesite": "andesito",
  "block.minecraft.polished_andesite": "polisita andesito",
  "block.minecraft.grass_block": "bloko di gazono",
  "block.minecraft.dirt": "sulo",
  "block.minecraft.coarse_dirt": "sulo grosiera",
  "block.minecraft.podzol": "podzolo",
  "block.minecraft.crimson_nylium": "nylio karmezina",
  "block.minecraft.warped_nylium": "nylio bizara",
  "block.minecraft.cobblestone": "eskombro",
  "block.minecraft.oak_planks": "planki querka",
  "block.minecraft.spruce_planks": "planki abieta",
  "block.minecraft.birch_planks": "planki birka",
  "block.minecraft.jungle_planks": "planki mahagoniera",
  "block.minecraft.acacia_planks": "planki akacia",
  "block.minecraft.dark_oak_planks": "planki obskurquerka",
  "block.minecraft.crimson_planks": "planki karmezina",
  "block.minecraft.warped_planks": "planki bizara",
  "block.minecraft.oak_sapling": "arboreto querka",
  "block.minecraft.spruce_sapling": "arboreto abieta",
  "block.minecraft.birch_sapling": "arboreto birka",
  "block.minecraft.jungle_sapling": "arboreto mahagoniera",
  "block.minecraft.acacia_sapling": "arboreto akacia",
  "block.minecraft.dark_oak_sapling": "aboreto obskurquerka",
  "block.minecraft.bedrock": "bazpetro",
  "block.minecraft.sand": "sablo",
  "block.minecraft.red_sand": "reda sablo",
  "block.minecraft.gravel": "gravio",
  "block.minecraft.gold_ore": "erco di oro",
  "block.minecraft.iron_ore": "erco di fero",
  "block.minecraft.coal_ore": "erco di karbono",
  "block.minecraft.nether_gold_ore": "erco di oro netherala",
  "block.minecraft.oak_log": "lenio querka",
  "block.minecraft.spruce_log": "lenio abieta",
  "block.minecraft.birch_log": "lenio birka",
  "block.minecraft.jungle_log": "lenio mahagoniera",
  "block.minecraft.acacia_log": "lenio akacia",
  "block.minecraft.dark_oak_log": "lenio obskurquerka",
  "block.minecraft.crimson_stem": "stipo karmezina",
  "block.minecraft.warped_stem": "stipo bizara",
  "block.minecraft.stripped_oak_log": "lenio querka sen kortico",
  "block.minecraft.stripped_spruce_log": "lenio abieta sen kortico",
  "block.minecraft.stripped_birch_log": "lenio birka sen kortico",
  "block.minecraft.stripped_jungle_log": "lenio mahagoniera sen kortico",
  "block.minecraft.stripped_acacia_log": "lenio akacia sen kortico",
  "block.minecraft.stripped_dark_oak_log": "lenio obskurquerka sen kortico",
  "block.minecraft.stripped_crimson_stem": "stipo karmezina sen kortico",
  "block.minecraft.stripped_warped_stem": "stipo bizara sen kortico",
  "block.minecraft.stripped_oak_wood": "ligno querka sen kortico",
  "block.minecraft.stripped_spruce_wood": "ligno abieta sen kortico",
  "block.minecraft.stripped_birch_wood": "ligno birka sen kortico",
  "block.minecraft.stripped_jungle_wood": "ligno mahagoniera sen kortico",
  "block.minecraft.stripped_acacia_wood": "ligno akacia sen kortico",
  "block.minecraft.stripped_dark_oak_wood": "ligno obskurquerka sen kortico",
  "block.minecraft.stripped_crimson_hyphae": "hyfei karmezina sen kortico",
  "block.minecraft.stripped_warped_hyphae": "hyfei bizara sen kortico",
  "block.minecraft.oak_wood": "ligno querka",
  "block.minecraft.spruce_wood": "ligno abieta",
  "block.minecraft.birch_wood": "ligno birka",
  "block.minecraft.jungle_wood": "ligno mahagoniera",
  "block.minecraft.acacia_wood": "ligno akacia",
  "block.minecraft.dark_oak_wood": "ligno obskurquerka",
  "block.minecraft.crimson_hyphae": "hyfei karmezina",
  "block.minecraft.warped_hyphae": "hyfei bizara",
  "block.minecraft.oak_leaves": "folii querka",
  "block.minecraft.spruce_leaves": "folii abieta",
  "block.minecraft.birch_leaves": "folii birka",
  "block.minecraft.jungle_leaves": "folii mahagoniera",
  "block.minecraft.acacia_leaves": "folii akacia",
  "block.minecraft.dark_oak_leaves": "folii obskurquerka",
  "block.minecraft.sponge": "sponjo",
  "block.minecraft.wet_sponge": "sponjo imbibita",
  "block.minecraft.glass": "vitro",
  "block.minecraft.lapis_ore": "erco di lapislazulo",
  "block.minecraft.lapis_block": "bloko di lapislazulo",
  "block.minecraft.dispenser": "lansilo",
  "block.minecraft.sandstone": "greso",
  "block.minecraft.chiseled_sandstone": "greso cizelita",
  "block.minecraft.cut_sandstone": "greso tailita",
  "block.minecraft.note_block": "notbloko",
  "block.minecraft.powered_rail": "relo di propulso",
  "block.minecraft.detector_rail": "ralo di detekteso",
  "block.minecraft.sticky_piston": "pistono adherema",
  "block.minecraft.cobweb": "aranereto",
  "block.minecraft.grass": "herbo",
  "block.minecraft.fern": "filiko",
  "block.minecraft.dead_bush": "arbusto mortinta",
  "block.minecraft.seagrass": "marherbo",
  "block.minecraft.sea_pickle": "piklo marala",
  "block.minecraft.piston": "pistono",
  "block.minecraft.white_wool": "blanka lano",
  "block.minecraft.orange_wool": "oranjea lano",
  "block.minecraft.magenta_wool": "magenta lano",
  "block.minecraft.light_blue_wool": "cielblua lano",
  "block.minecraft.yellow_wool": "flava lano",
  "block.minecraft.lime_wool": "klarverda lano",
  "block.minecraft.pink_wool": "rozea lano",
  "block.minecraft.gray_wool": "griza lano",
  "block.minecraft.light_gray_wool": "klargriza lano",
  "block.minecraft.cyan_wool": "cyana lano",
  "block.minecraft.purple_wool": "purpura lano",
  "block.minecraft.blue_wool": "blua lano",
  "block.minecraft.brown_wool": "bruna lano",
  "block.minecraft.green_wool": "verda lano",
  "block.minecraft.red_wool": "reda lano",
  "block.minecraft.black_wool": "nigra lano",
  "block.minecraft.dandelion": "leondento",
  "block.minecraft.poppy": "papavero",
  "block.minecraft.blue_orchid": "orkideo blua",
  "block.minecraft.allium": "alliumo",
  "block.minecraft.azure_bluet": "azura houstonio",
  "block.minecraft.red_tulip": "reda tulipo",
  "block.minecraft.orange_tulip": "oranjea tulipo",
  "block.minecraft.white_tulip": "blanka tulipo",
  "block.minecraft.pink_tulip": "rozea tulipo",
  "block.minecraft.oxeye_daisy": "margrito",
  "block.minecraft.cornflower": "aciano",
  "block.minecraft.lily_of_the_valley": "maifloro",
  "block.minecraft.wither_rose": "witherrozo",
  "block.minecraft.brown_mushroom": "fungo bruna",
  "block.minecraft.red_mushroom": "reda fungo",
  "block.minecraft.crimson_fungus": "fungo karmezina",
  "block.minecraft.warped_fungus": "fungo bizara",
  "block.minecraft.crimson_roots": "radiki karmezina",
  "block.minecraft.warped_roots": "radiki bizara",
  "block.minecraft.nether_sprouts": "sprosi di nether",
  "block.minecraft.weeping_vines": "viti ploranta",
  "block.minecraft.twisting_vines": "viti tordanta",
  "block.minecraft.sugar_cane": "sukrokano",
  "block.minecraft.kelp": "algo",
  "block.minecraft.bamboo": "bambuo",
  "block.minecraft.gold_block": "bloko di oro",
  "block.minecraft.iron_block": "bloko di fero",
  "block.minecraft.oak_slab": "plako querka",
  "block.minecraft.spruce_slab": "plako abieta",
  "block.minecraft.birch_slab": "plako birka",
  "block.minecraft.jungle_slab": "plako mahagoniera",
  "block.minecraft.acacia_slab": "plako akacia",
  "block.minecraft.dark_oak_slab": "plako obskurquerka",
  "block.minecraft.crimson_slab": "plako karmezina",
  "block.minecraft.warped_slab": "plako bizara",
  "block.minecraft.stone_slab": "plako di petro",
  "block.minecraft.smooth_stone_slab": "plako di petro glata",
  "block.minecraft.sandstone_slab": "plako di greso",
  "block.minecraft.cut_sandstone_slab": "plako di greso tailita",
  "block.minecraft.petrified_oak_slab": "petrigita plako querka",
  "block.minecraft.cobblestone_slab": "plako di eskombro",
  "block.minecraft.brick_slab": "plako di briko",
  "block.minecraft.stone_brick_slab": "plako di petrabriko",
  "block.minecraft.nether_brick_slab": "plako di netherbriko",
  "block.minecraft.quartz_slab": "plako di quarco",
  "block.minecraft.red_sandstone_slab": "plako di greso reda",
  "block.minecraft.cut_red_sandstone_slab": "plako di reda greso tailita",
  "block.minecraft.purpur_slab": "plako di purpuro",
  "block.minecraft.prismarine_slab": "plako di prismarino",
  "block.minecraft.prismarine_brick_slab": "plako di briko prismarina",
  "block.minecraft.dark_prismarine_slab": "plako di prismarino obskura",
  "block.minecraft.smooth_quartz": "bloko di quarco glata",
  "block.minecraft.smooth_red_sandstone": "reda greso glata",
  "block.minecraft.smooth_sandstone": "greso glata",
  "block.minecraft.smooth_stone": "petro glata",
  "block.minecraft.bricks": "briki",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "biblioteko",
  "block.minecraft.mossy_cobblestone": "eskombro muskoza",
  "block.minecraft.obsidian": "obsidiano",
  "block.minecraft.torch": "torcho",
  "block.minecraft.end_rod": "bastono di end",
  "block.minecraft.chorus_plant": "chorusplanto",
  "block.minecraft.chorus_flower": "chorusfloro",
  "block.minecraft.purpur_block": "bloko di purpuro",
  "block.minecraft.purpur_pillar": "kolono di purpuro",
  "block.minecraft.purpur_stairs": "eskalero di purpuro",
  "block.minecraft.spawner": "frayifanto",
  "block.minecraft.oak_stairs": "eskalero querka",
  "block.minecraft.chest": "kofro",
  "block.minecraft.diamond_ore": "erco di diamanto",
  "block.minecraft.diamond_block": "bloko di diamanto",
  "block.minecraft.crafting_table": "tablo di fabrikado",
  "block.minecraft.farmland": "farmsulo",
  "block.minecraft.furnace": "furnazo",
  "block.minecraft.ladder": "skalo",
  "block.minecraft.rail": "relo",
  "block.minecraft.cobblestone_stairs": "eskalero di eskombro",
  "block.minecraft.lever": "levero",
  "block.minecraft.stone_pressure_plate": "petra presoplako",
  "block.minecraft.oak_pressure_plate": "presoplako querka",
  "block.minecraft.spruce_pressure_plate": "presoplako abieta",
  "block.minecraft.birch_pressure_plate": "presoplako birka",
  "block.minecraft.jungle_pressure_plate": "presoplako mahagoniera",
  "block.minecraft.acacia_pressure_plate": "presoplako akacia",
  "block.minecraft.dark_oak_pressure_plate": "presoplako obskurquerka",
  "block.minecraft.crimson_pressure_plate": "presoplako karmezina",
  "block.minecraft.warped_pressure_plate": "presoplako bizara",
  "block.minecraft.polished_blackstone_pressure_plate": "polished blackstone pressure plate",
  "block.minecraft.redstone_ore": "erco di redstoneo",
  "block.minecraft.redstone_torch": "torch di redstoneo",
  "block.minecraft.snow": "nivo",
  "block.minecraft.ice": "glacio",
  "block.minecraft.snow_block": "bloko di nivo",
  "block.minecraft.cactus": "kaktuso",
  "block.minecraft.clay": "argilo",
  "block.minecraft.jukebox": "muzikbuxo",
  "block.minecraft.oak_fence": "fenco querka",
  "block.minecraft.spruce_fence": "fenco abieta",
  "block.minecraft.birch_fence": "fenco birka",
  "block.minecraft.jungle_fence": "fenco mahagoniera",
  "block.minecraft.acacia_fence": "fenco akacia",
  "block.minecraft.dark_oak_fence": "fenco obskurquerka",
  "block.minecraft.crimson_fence": "fenco karmezina",
  "block.minecraft.warped_fence": "fenco bizara",
  "block.minecraft.pumpkin": "kukurbito",
  "block.minecraft.carved_pumpkin": "skultata kukurbito",
  "block.minecraft.netherrack": "netherracko",
  "block.minecraft.soul_sand": "anmosablo",
  "block.minecraft.soul_soil": "anmosulo",
  "block.minecraft.basalt": "bazalto",
  "block.minecraft.polished_basalt": "bazalto polisita",
  "block.minecraft.soul_torch": "soul torch",
  "block.minecraft.glowstone": "lumpetro",
  "block.minecraft.jack_o_lantern": "kukurbita lanterno",
  "block.minecraft.oak_trapdoor": "trapo querka",
  "block.minecraft.spruce_trapdoor": "trapo abieta",
  "block.minecraft.birch_trapdoor": "trapo birka",
  "block.minecraft.jungle_trapdoor": "trapo mahagoniera",
  "block.minecraft.acacia_trapdoor": "trapo akacia",
  "block.minecraft.dark_oak_trapdoor": "trapo obskurquerka",
  "block.minecraft.crimson_trapdoor": "trapo karmezina",
  "block.minecraft.warped_trapdoor": "trapo bizara",
  "block.minecraft.infested_stone": "infestita petro",
  "block.minecraft.infested_cobblestone": "infestita eskombro",
  "block.minecraft.infested_stone_bricks": "infestita petrabriki",
  "block.minecraft.infested_mossy_stone_bricks": "infestita petrabriki muskoza",
  "block.minecraft.infested_cracked_stone_bricks": "infestita petrabriki krakita",
  "block.minecraft.infested_chiseled_stone_bricks": "infestita petrabriki cizelita",
  "block.minecraft.stone_bricks": "petrabriki",
  "block.minecraft.mossy_stone_bricks": "petrabriki muskoza",
  "block.minecraft.cracked_stone_bricks": "petrabriko krakita",
  "block.minecraft.chiseled_stone_bricks": "petrabriki cizelita",
  "block.minecraft.brown_mushroom_block": "bloko di fungo bruna",
  "block.minecraft.red_mushroom_block": "bloki di fungo reda",
  "block.minecraft.mushroom_stem": "stipito di fungo",
  "block.minecraft.iron_bars": "greto fera",
  "block.minecraft.chain": "katenar",
  "block.minecraft.glass_pane": "vitrokarelo",
  "block.minecraft.melon": "melono",
  "block.minecraft.vine": "viti",
  "block.minecraft.oak_fence_gate": "pordeto querka",
  "block.minecraft.spruce_fence_gate": "pordeto abieta",
  "block.minecraft.birch_fence_gate": "pordeto birka",
  "block.minecraft.jungle_fence_gate": "pordeto mahagoniera",
  "block.minecraft.acacia_fence_gate": "pordeto akacia",
  "block.minecraft.dark_oak_fence_gate": "pordeto obskurquerka",
  "block.minecraft.crimson_fence_gate": "pordeto karmezina",
  "block.minecraft.warped_fence_gate": "pordeto bizara",
  "block.minecraft.brick_stairs": "eskalero di briko",
  "block.minecraft.stone_brick_stairs": "eskalero di petrabriko",
  "block.minecraft.mycelium": "mycelio",
  "block.minecraft.lily_pad": "nenufaro",
  "block.minecraft.nether_bricks": "netherbriki",
  "block.minecraft.cracked_nether_bricks": "cracked nether bricks",
  "block.minecraft.chiseled_nether_bricks": "chiseled nether bricks",
  "block.minecraft.nether_brick_fence": "netherbrika fenco",
  "block.minecraft.nether_brick_stairs": "eskalero di netherbriko",
  "block.minecraft.enchanting_table": "sorcotablo",
  "block.minecraft.end_portal_frame": "portalframo di end",
  "block.minecraft.end_stone": "petro di end",
  "block.minecraft.end_stone_bricks": "petrabriki di end",
  "block.minecraft.dragon_egg": "ovo di drako",
  "block.minecraft.redstone_lamp": "lampo di redstoneo",
  "block.minecraft.sandstone_stairs": "eskalero di greso",
  "block.minecraft.emerald_ore": "erco di smeraldo",
  "block.minecraft.ender_chest": "enderkofro",
  "block.minecraft.tripwire_hook": "hoko di insidia filo",
  "block.minecraft.emerald_block": "bloko di smeraldo",
  "block.minecraft.spruce_stairs": "eskalero abieta",
  "block.minecraft.birch_stairs": "eskalero birka",
  "block.minecraft.jungle_stairs": "eskalero mahagoniera",
  "block.minecraft.crimson_stairs": "eskalero karmezina",
  "block.minecraft.warped_stairs": "eskalero bizara",
  "block.minecraft.command_block": "bloko di komandi",
  "block.minecraft.beacon": "baliso",
  "block.minecraft.cobblestone_wall": "muro di eskombro",
  "block.minecraft.mossy_cobblestone_wall": "muro di eskombro muskoza",
  "block.minecraft.brick_wall": "muro di briki",
  "block.minecraft.prismarine_wall": "muro di prismarino",
  "block.minecraft.red_sandstone_wall": "muro di reda greso",
  "block.minecraft.mossy_stone_brick_wall": "muro di petrabriki muskoza",
  "block.minecraft.granite_wall": "muro granita",
  "block.minecraft.stone_brick_wall": "muro di petrabriki",
  "block.minecraft.nether_brick_wall": "muro di netherbriki",
  "block.minecraft.andesite_wall": "muro andesita",
  "block.minecraft.red_nether_brick_wall": "muro di reda netherbriki",
  "block.minecraft.sandstone_wall": "muro di greso",
  "block.minecraft.end_stone_brick_wall": "muro di petrabriki di end",
  "block.minecraft.diorite_wall": "muro diorita",
  "block.minecraft.blackstone_wall": "muro di nigrapetro",
  "block.minecraft.polished_blackstone_wall": "polished blackstone wall",
  "block.minecraft.polished_blackstone_brick_wall": "polished blackstone brick wall",
  "block.minecraft.stone_button": "petra butono",
  "block.minecraft.oak_button": "butono querka",
  "block.minecraft.spruce_button": "butono abieta",
  "block.minecraft.birch_button": "butono birka",
  "block.minecraft.jungle_button": "butono mahagoniera",
  "block.minecraft.acacia_button": "butono akacia",
  "block.minecraft.dark_oak_button": "butono obskurquerka",
  "block.minecraft.crimson_button": "butono karmezina",
  "block.minecraft.warped_button": "butono bizara",
  "block.minecraft.polished_blackstone_button": "polished blackstone button",
  "block.minecraft.anvil": "amboso",
  "block.minecraft.chipped_anvil": "amboso ruptetita",
  "block.minecraft.damaged_anvil": "amboso domajita",
  "block.minecraft.trapped_chest": "kofro insidiita",
  "block.minecraft.light_weighted_pressure_plate": "lejera presoplako pezanta",
  "block.minecraft.heavy_weighted_pressure_plate": "grava presoplako pezanta",
  "block.minecraft.daylight_detector": "detektanto di dilumo",
  "block.minecraft.redstone_block": "bloko di redstoneo",
  "block.minecraft.nether_quartz_ore": "erco di quarco",
  "block.minecraft.hopper": "funelego",
  "block.minecraft.chiseled_quartz_block": "bloko di quarco cizelita",
  "block.minecraft.quartz_block": "bloko di quarco",
  "block.minecraft.quartz_bricks": "quartz bricks",
  "block.minecraft.quartz_pillar": "kolono di quarco",
  "block.minecraft.quartz_stairs": "eskalero di quarco",
  "block.minecraft.activator_rail": "relo aktiviga",
  "block.minecraft.dropper": "distributilo",
  "block.minecraft.white_terracotta": "blanka terakoto",
  "block.minecraft.orange_terracotta": "oranjea terakoto",
  "block.minecraft.magenta_terracotta": "magenta terakoto",
  "block.minecraft.light_blue_terracotta": "cielblua terakoto",
  "block.minecraft.yellow_terracotta": "flava terakoto",
  "block.minecraft.lime_terracotta": "klarverda terakoto",
  "block.minecraft.pink_terracotta": "rozea terakoto",
  "block.minecraft.gray_terracotta": "griza terakoto",
  "block.minecraft.light_gray_terracotta": "klargriza terakoto",
  "block.minecraft.cyan_terracotta": "cyana terakoto",
  "block.minecraft.purple_terracotta": "purpura terakoto",
  "block.minecraft.blue_terracotta": "blua terakoto",
  "block.minecraft.brown_terracotta": "bruna terakoto",
  "block.minecraft.green_terracotta": "verda terakoto",
  "block.minecraft.red_terracotta": "reda terakoto",
  "block.minecraft.black_terracotta": "nigra terakoto",
  "block.minecraft.barrier": "barilo",
  "block.minecraft.iron_trapdoor": "trapo fera",
  "block.minecraft.hay_block": "bloko di feno",
  "block.minecraft.white_carpet": "blanka tapiso",
  "block.minecraft.orange_carpet": "oranjea tapiso",
  "block.minecraft.magenta_carpet": "magenta tapiso",
  "block.minecraft.light_blue_carpet": "cielblua tapiso",
  "block.minecraft.yellow_carpet": "flava tapiso",
  "block.minecraft.lime_carpet": "klarverda tapiso",
  "block.minecraft.pink_carpet": "rozea tapiso",
  "block.minecraft.gray_carpet": "griza tapiso",
  "block.minecraft.light_gray_carpet": "klargriza tapiso",
  "block.minecraft.cyan_carpet": "cyana tapiso",
  "block.minecraft.purple_carpet": "purpura tapiso",
  "block.minecraft.blue_carpet": "blua tapiso",
  "block.minecraft.brown_carpet": "bruna tapiso",
  "block.minecraft.green_carpet": "verda tapiso",
  "block.minecraft.red_carpet": "reda tapiso",
  "block.minecraft.black_carpet": "nigra tapiso",
  "block.minecraft.terracotta": "terakoto",
  "block.minecraft.coal_block": "bloko di karbono",
  "block.minecraft.packed_ice": "glacio ferma",
  "block.minecraft.acacia_stairs": "eskalero akacia",
  "block.minecraft.dark_oak_stairs": "eskalero obskurquerka",
  "block.minecraft.slime_block": "bloko di slamo",
  "block.minecraft.grass_path": "herbaleo",
  "block.minecraft.sunflower": "sunfloro",
  "block.minecraft.lilac": "lilaco",
  "block.minecraft.rose_bush": "roziero",
  "block.minecraft.peony": "peonio",
  "block.minecraft.tall_grass": "herbo alta",
  "block.minecraft.large_fern": "filikego",
  "block.minecraft.white_stained_glass": "blanka vitro tintita",
  "block.minecraft.orange_stained_glass": "oranjea vitro tintita",
  "block.minecraft.magenta_stained_glass": "magenta vitro tintita",
  "block.minecraft.light_blue_stained_glass": "cielblua vitro tintita",
  "block.minecraft.yellow_stained_glass": "flava vitro tintita",
  "block.minecraft.lime_stained_glass": "klarverda vitro tintita",
  "block.minecraft.pink_stained_glass": "rozea vitro tintita",
  "block.minecraft.gray_stained_glass": "griza vitro tintita",
  "block.minecraft.light_gray_stained_glass": "klargriza vitro tintita",
  "block.minecraft.cyan_stained_glass": "cyana vitro tintita",
  "block.minecraft.purple_stained_glass": "purpura vitro tintita",
  "block.minecraft.blue_stained_glass": "blua vitro tintita",
  "block.minecraft.brown_stained_glass": "bruna vitro tintita",
  "block.minecraft.green_stained_glass": "verda vitro tintita",
  "block.minecraft.red_stained_glass": "reda vitro tintita",
  "block.minecraft.black_stained_glass": "nigra vitro tintita",
  "block.minecraft.white_stained_glass_pane": "blanka vitrokarelo tintita",
  "block.minecraft.orange_stained_glass_pane": "oranjea vitrokarelo tintita",
  "block.minecraft.magenta_stained_glass_pane": "magenta vitrokarelo tintita",
  "block.minecraft.light_blue_stained_glass_pane": "cielblua vitrokarelo tintita",
  "block.minecraft.yellow_stained_glass_pane": "flava vitrokarelo tintita",
  "block.minecraft.lime_stained_glass_pane": "klarverda vitrokarelo tintita",
  "block.minecraft.pink_stained_glass_pane": "rozea vitrokarelo tintita",
  "block.minecraft.gray_stained_glass_pane": "griza vitrokarelo tintita",
  "block.minecraft.light_gray_stained_glass_pane": "klargriza vitrokarelo tintita",
  "block.minecraft.cyan_stained_glass_pane": "cyana vitrokarelo tintita",
  "block.minecraft.purple_stained_glass_pane": "purpura vitrokarelo tintita",
  "block.minecraft.blue_stained_glass_pane": "blua vitrokarelo tintita",
  "block.minecraft.brown_stained_glass_pane": "bruna vitrokarelo tintita",
  "block.minecraft.green_stained_glass_pane": "verda vitrokarelo tintita",
  "block.minecraft.red_stained_glass_pane": "reda vitrokarelo tintita",
  "block.minecraft.black_stained_glass_pane": "nigra vitrokarelo tintita",
  "block.minecraft.prismarine": "prismarino",
  "block.minecraft.prismarine_bricks": "briki di prismarino",
  "block.minecraft.dark_prismarine": "prismarino obskura",
  "block.minecraft.prismarine_stairs": "eskalero di prismarino",
  "block.minecraft.prismarine_brick_stairs": "eskalero di briki prismarina",
  "block.minecraft.dark_prismarine_stairs": "eskalero di prismarino obskura",
  "block.minecraft.sea_lantern": "marlanterno",
  "block.minecraft.red_sandstone": "reda greso",
  "block.minecraft.chiseled_red_sandstone": "reda greso cizelita",
  "block.minecraft.cut_red_sandstone": "reda greso tailita",
  "block.minecraft.red_sandstone_stairs": "eskalero di reda greso",
  "block.minecraft.repeating_command_block": "bloko di komandi iteranta",
  "block.minecraft.chain_command_block": "bloko di komandi katenita",
  "block.minecraft.magma_block": "bloko di magmo",
  "block.minecraft.nether_wart_block": "bloko di netherveruko",
  "block.minecraft.warped_wart_block": "bloko di veruko bizara",
  "block.minecraft.red_nether_bricks": "reda netherbriki",
  "block.minecraft.bone_block": "bloko di osto",
  "block.minecraft.structure_void": "vakuo strukturala",
  "block.minecraft.observer": "observilo",
  "block.minecraft.shulker_box": "buxo di shulkero",
  "block.minecraft.white_shulker_box": "blanka buxo di shulkero",
  "block.minecraft.orange_shulker_box": "oranjea buxo di shulkero",
  "block.minecraft.magenta_shulker_box": "magenta buxo di shulkero",
  "block.minecraft.light_blue_shulker_box": "cielblua buxo di shulkero",
  "block.minecraft.yellow_shulker_box": "flava buxo di shulkero",
  "block.minecraft.lime_shulker_box": "klarverda buxo di shulkero",
  "block.minecraft.pink_shulker_box": "rozea buxo di shulkero",
  "block.minecraft.gray_shulker_box": "griza buxo di shulkero",
  "block.minecraft.light_gray_shulker_box": "klargriza buxo di shulkero",
  "block.minecraft.cyan_shulker_box": "cyana buxo di shulkero",
  "block.minecraft.purple_shulker_box": "purpura buxo di shulkero",
  "block.minecraft.blue_shulker_box": "blua buxo di shulkero",
  "block.minecraft.brown_shulker_box": "bruna buxo di shulkero",
  "block.minecraft.green_shulker_box": "verda buxo di shulkero",
  "block.minecraft.red_shulker_box": "reda buxo di shulkero",
  "block.minecraft.black_shulker_box": "nigra buxo di shulkero",
  "block.minecraft.white_glazed_terracotta": "blanka terakoto glezita",
  "block.minecraft.orange_glazed_terracotta": "oranjea terakoto glezita",
  "block.minecraft.magenta_glazed_terracotta": "magenta terakoto glezita",
  "block.minecraft.light_blue_glazed_terracotta": "cielblua terakoto glezita",
  "block.minecraft.yellow_glazed_terracotta": "flava terakoto glezita",
  "block.minecraft.lime_glazed_terracotta": "klarverda terakoto glezita",
  "block.minecraft.pink_glazed_terracotta": "rozea terakoto glezita",
  "block.minecraft.gray_glazed_terracotta": "griza terakoto glezita",
  "block.minecraft.light_gray_glazed_terracotta": "klargriza terakoto glezita",
  "block.minecraft.cyan_glazed_terracotta": "cyana terakoto glezita",
  "block.minecraft.purple_glazed_terracotta": "purpura terakoto glezita",
  "block.minecraft.blue_glazed_terracotta": "blua terakoto glezita",
  "block.minecraft.brown_glazed_terracotta": "bruna terakoto glezita",
  "block.minecraft.green_glazed_terracotta": "verda terakoto glezita",
  "block.minecraft.red_glazed_terracotta": "reda terakoto glezita",
  "block.minecraft.black_glazed_terracotta": "nigra terakoto glezita",
  "block.minecraft.white_concrete": "blanka betono",
  "block.minecraft.orange_concrete": "oranjea betono",
  "block.minecraft.magenta_concrete": "magenta betono",
  "block.minecraft.light_blue_concrete": "cielblua betono",
  "block.minecraft.yellow_concrete": "flava betono",
  "block.minecraft.lime_concrete": "klarverda betono",
  "block.minecraft.pink_concrete": "rozea betono",
  "block.minecraft.gray_concrete": "griza betono",
  "block.minecraft.light_gray_concrete": "klargriza betono",
  "block.minecraft.cyan_concrete": "cyana betono",
  "block.minecraft.purple_concrete": "purpura betono",
  "block.minecraft.blue_concrete": "blua betono",
  "block.minecraft.brown_concrete": "bruna betono",
  "block.minecraft.green_concrete": "verda betono",
  "block.minecraft.red_concrete": "reda betono",
  "block.minecraft.black_concrete": "nigra betono",
  "block.minecraft.white_concrete_powder": "blanka betonpulvero",
  "block.minecraft.orange_concrete_powder": "oranjea betonpulvero",
  "block.minecraft.magenta_concrete_powder": "magenta betonpulvero",
  "block.minecraft.light_blue_concrete_powder": "cielblua betonpulvero",
  "block.minecraft.yellow_concrete_powder": "flava betonpulvero",
  "block.minecraft.lime_concrete_powder": "klarverda betonpulvero",
  "block.minecraft.pink_concrete_powder": "rozea betonpulvero",
  "block.minecraft.gray_concrete_powder": "griza betonpulvero",
  "block.minecraft.light_gray_concrete_powder": "klargriza betonpulvero",
  "block.minecraft.cyan_concrete_powder": "cyana betonpulvero",
  "block.minecraft.purple_concrete_powder": "purpura betonpulvero",
  "block.minecraft.blue_concrete_powder": "blua betonpulvero",
  "block.minecraft.brown_concrete_powder": "bruna betonpulvero",
  "block.minecraft.green_concrete_powder": "verda betonpulvero",
  "block.minecraft.red_concrete_powder": "reda betonpulvero",
  "block.minecraft.black_concrete_powder": "nigra betonpulvero",
  "block.minecraft.turtle_egg": "ovo di tortugo",
  "block.minecraft.dead_tube_coral_block": "bloko di pipeta koralio mortinta",
  "block.minecraft.dead_brain_coral_block": "bloko di cerebrala koralio mortinta",
  "block.minecraft.dead_bubble_coral_block": "bloko di buleta koralio mortinta",
  "block.minecraft.dead_fire_coral_block": "bloko di fairala koralio mortinta",
  "block.minecraft.dead_horn_coral_block": "bloko di korna koralio mortinta",
  "block.minecraft.tube_coral_block": "bloko di pipeta koralio",
  "block.minecraft.brain_coral_block": "bloko di cerebrala koralio",
  "block.minecraft.bubble_coral_block": "bloko di buleta koralio",
  "block.minecraft.fire_coral_block": "bloko di fairala koralio",
  "block.minecraft.horn_coral_block": "bloko di korna koralio",
  "block.minecraft.tube_coral": "pipeta koralio",
  "block.minecraft.brain_coral": "cerebrala koralio",
  "block.minecraft.bubble_coral": "buleta koralio",
  "block.minecraft.fire_coral": "fairala koralio",
  "block.minecraft.horn_coral": "korna koralio",
  "block.minecraft.dead_brain_coral": "cerebrala koralio mortinta",
  "block.minecraft.dead_bubble_coral": "buleta koralio mortinta",
  "block.minecraft.dead_fire_coral": "fairala koralio mortinta",
  "block.minecraft.dead_horn_coral": "korna koralio mortinta",
  "block.minecraft.dead_tube_coral": "pipeta koralio mortinta",
  "block.minecraft.tube_coral_fan": "fano di pipeta koralio",
  "block.minecraft.brain_coral_fan": "fano di cerebrala koralio",
  "block.minecraft.bubble_coral_fan": "fano di buleta koralio",
  "block.minecraft.fire_coral_fan": "fano di fairala koralio",
  "block.minecraft.horn_coral_fan": "fano di korna koralio",
  "block.minecraft.dead_tube_coral_fan": "fano di pipeta koralio mortinta",
  "block.minecraft.dead_brain_coral_fan": "fano di cerebrala koralio mortinta",
  "block.minecraft.dead_bubble_coral_fan": "fano di buleta koralio mortinta",
  "block.minecraft.dead_fire_coral_fan": "fano di fairala koralio mortinta",
  "block.minecraft.dead_horn_coral_fan": "fano di korna koralio mortinta",
  "block.minecraft.blue_ice": "glacio blua",
  "block.minecraft.conduit": "povoduktilo",
  "block.minecraft.polished_granite_stairs": "polisita eskalero granita",
  "block.minecraft.smooth_red_sandstone_stairs": "eskalero di reda greso glata",
  "block.minecraft.mossy_stone_brick_stairs": "eskalero di petrabriki muskoza",
  "block.minecraft.polished_diorite_stairs": "polisita eskalero diorita",
  "block.minecraft.mossy_cobblestone_stairs": "eskalero di muskoza eskombro",
  "block.minecraft.end_stone_brick_stairs": "eskalero di petrabriki di end",
  "block.minecraft.stone_stairs": "eskalero di petro",
  "block.minecraft.smooth_sandstone_stairs": "eskalero di greso glata",
  "block.minecraft.smooth_quartz_stairs": "eskalero di quarco glata",
  "block.minecraft.granite_stairs": "eskalero granita",
  "block.minecraft.andesite_stairs": "eskalero andesita",
  "block.minecraft.red_nether_brick_stairs": "eskalero di reda netherbriki",
  "block.minecraft.polished_andesite_stairs": "polisita eskalero andesita",
  "block.minecraft.diorite_stairs": "eskalero diorita",
  "block.minecraft.polished_granite_slab": "polisita plako granita",
  "block.minecraft.smooth_red_sandstone_slab": "plako di reda greso glata",
  "block.minecraft.mossy_stone_brick_slab": "plako di petrabriki muskoza",
  "block.minecraft.polished_diorite_slab": "polisita plako diorita",
  "block.minecraft.mossy_cobblestone_slab": "plako di eskombro muskoza",
  "block.minecraft.end_stone_brick_slab": "plako di petrabriki di end",
  "block.minecraft.smooth_sandstone_slab": "plako di greso glata",
  "block.minecraft.smooth_quartz_slab": "plako di quarco glata",
  "block.minecraft.granite_slab": "plako granita",
  "block.minecraft.andesite_slab": "plako andesita",
  "block.minecraft.red_nether_brick_slab": "plako di reda netherbriki",
  "block.minecraft.polished_andesite_slab": "polisita plako andesita",
  "block.minecraft.diorite_slab": "plako diorita",
  "block.minecraft.scaffolding": "eshafodo",
  "block.minecraft.iron_door": "pordo fera",
  "block.minecraft.oak_door": "pordo querka",
  "block.minecraft.spruce_door": "pordo abieta",
  "block.minecraft.birch_door": "pordo birka",
  "block.minecraft.jungle_door": "pordo mahagoniera",
  "block.minecraft.acacia_door": "pordo akacia",
  "block.minecraft.dark_oak_door": "pordo obskurquerka",
  "block.minecraft.crimson_door": "pordo karmezina",
  "block.minecraft.warped_door": "pordo bizara",
  "block.minecraft.repeater": "repetilo di redstoneo",
  "block.minecraft.comparator": "komparilo di redstoneo",
  "block.minecraft.structure_block": "bloko strukturala",
  "block.minecraft.jigsaw": "konstruktbloko",
  "item.minecraft.turtle_helmet": "skalio di torguto□□when on head:□+2 homarmaro",
  "item.minecraft.scute": "skalio",
  "item.minecraft.iron_shovel": "shovelo fera□□when in main hand:□+3.5 domajo di atako□-3 rapideso di atako",
  "item.minecraft.iron_pickaxe": "piocho fera□□when in main hand:□+3 domajo di atako□-2.8 rapideso di atako",
  "item.minecraft.iron_axe": "hakilo fera□□when in main hand:□+8 domajo di atako□-3.1 rapideso di atako",
  "item.minecraft.flint_and_steel": "silexo e stalo",
  "item.minecraft.apple": "pomo",
  "item.minecraft.bow": "arkarmo",
  "item.minecraft.arrow": "flecho",
  "item.minecraft.coal": "karbono",
  "item.minecraft.charcoal": "lignakarbono",
  "item.minecraft.diamond": "diamanto",
  "item.minecraft.iron_ingot": "lingoto fera",
  "item.minecraft.gold_ingot": "lingoto ora",
  "item.minecraft.netherite_ingot": "lingoto netherita",
  "item.minecraft.netherite_scrap": "fragmento netherita",
  "item.minecraft.iron_sword": "espado fera□□when in main hand:□+5 domajo di atako□-2.4 rapideso di atako",
  "item.minecraft.wooden_sword": "espado ligna□□when in main hand:□+3 domajo di atako□-2.4 rapideso di atako",
  "item.minecraft.wooden_shovel": "shovelo ligna□□when in main hand:□+1.5 domajo di atako□-3 rapideso di atako",
  "item.minecraft.wooden_pickaxe": "piocho ligna□□when in main hand:□+1 domajo di atako□-2.8 rapideso di atako",
  "item.minecraft.wooden_axe": "hakilo ligna□□when in main hand:□+6 domajo di atako□-3.2 rapideso di atako",
  "item.minecraft.stone_sword": "espado petra□□when in main hand:□+4 domajo di atako□-2.4 rapideso di atako",
  "item.minecraft.stone_shovel": "shovelo petra□□when in main hand:□+2.5 domajo di atako□-3 rapideso di atako",
  "item.minecraft.stone_pickaxe": "piocho petra□□when in main hand:□+2 domajo di atako□-2.8 rapideso di atako",
  "item.minecraft.stone_axe": "hakilo petra□□when in main hand:□+8 domajo di atako□-3.2 rapideso di atako",
  "item.minecraft.diamond_sword": "espado diamanta□□when in main hand:□+6 domajo di atako□-2.4 rapideso di atako",
  "item.minecraft.diamond_shovel": "shovelo diamanta□□when in main hand:□+4.5 domajo di atako□-3 rapideso di atako",
  "item.minecraft.diamond_pickaxe": "piocho diamanta□□when in main hand:□+4 domajo di atako□-2.8 rapideso di atako",
  "item.minecraft.diamond_axe": "hakilo diamanta□□when in main hand:□+8 domajo di atako□-3 rapideso di atako",
  "item.minecraft.stick": "bastono",
  "item.minecraft.bowl": "bolo",
  "item.minecraft.mushroom_stew": "fungoraguto",
  "item.minecraft.golden_sword": "espado ora□□when in main hand:□+3 domajo di atako□-2.4 rapideso di atako",
  "item.minecraft.golden_shovel": "shovelo ora□□when in main hand:□+1.5 domajo di atako□-3 rapideso di atako",
  "item.minecraft.golden_pickaxe": "piocho ora□□when in main hand:□+1 domajo di atako□-2.8 rapideso di atako",
  "item.minecraft.golden_axe": "hakilo ora□□when in main hand:□+6 domajo di atako□-3 rapideso di atako",
  "item.minecraft.netherite_sword": "espado netherita□□when in main hand:□+7 domajo di atako□-2.4 rapideso di atako",
  "item.minecraft.netherite_shovel": "shovel netherita□□when in main hand:□+5.5 domajo di atako□-3 rapideso di atako",
  "item.minecraft.netherite_pickaxe": "piocho netherita□□when in main hand:□+5 domajo di atako□-2.8 rapideso di atako",
  "item.minecraft.netherite_axe": "hakilo netherita□□when in main hand:□+9 domajo di atako□-3 rapideso di atako",
  "item.minecraft.string": "filo",
  "item.minecraft.feather": "plumo",
  "item.minecraft.gunpowder": "kanonpulvero",
  "item.minecraft.wooden_hoe": "bineto ligna□□when in main hand:□-3 rapideso di atako",
  "item.minecraft.stone_hoe": "bineto petra□□when in main hand:□-2 rapideso di atako",
  "item.minecraft.iron_hoe": "bineto fera□□when in main hand:□-1 rapideso di atako",
  "item.minecraft.diamond_hoe": "bineto diamanta□□when in main hand:",
  "item.minecraft.golden_hoe": "bineto ora□□when in main hand:□-3 rapideso di atako",
  "item.minecraft.netherite_hoe": "bineto netherita□□when in main hand:",
  "item.minecraft.wheat_seeds": "semini di frumento",
  "item.minecraft.wheat": "frumento",
  "item.minecraft.bread": "pano",
  "item.minecraft.leather_helmet": "boneto ledra□□when on head:□+1 homarmaro",
  "item.minecraft.leather_chestplate": "tuniko ledra□□when on body:□+3 homarmaro",
  "item.minecraft.leather_leggings": "pantaloni ledra□□when on legs:□+2 homarmaro",
  "item.minecraft.leather_boots": "boti ledra□□when on feet:□+1 homarmaro",
  "item.minecraft.chainmail_helmet": "helmo mashkuta□□when on head:□+2 homarmaro",
  "item.minecraft.chainmail_chestplate": "torsokuraso mashkuta□□when on body:□+5 homarmaro",
  "item.minecraft.chainmail_leggings": "pantaloni mashkuta□□when on legs:□+4 homarmaro",
  "item.minecraft.chainmail_boots": "boti mashkuta□□when on feet:□+1 homarmaro",
  "item.minecraft.iron_helmet": "helmo fera□□when on head:□+2 homarmaro",
  "item.minecraft.iron_chestplate": "torokuraso fera□□when on body:□+6 homarmaro",
  "item.minecraft.iron_leggings": "pantaloni fera□□when on legs:□+5 homarmaro",
  "item.minecraft.iron_boots": "boti fera□□when on feet:□+2 homarmaro",
  "item.minecraft.diamond_helmet": "helmo diamanta□□when on head:□+3 homarmaro□+2 hardeso di homarmaro",
  "item.minecraft.diamond_chestplate": "torokuraso diamanta□□when on body:□+8 homarmaro□+2 hardeso di homarmaro",
  "item.minecraft.diamond_leggings": "pantaloni diamanta□□when on legs:□+6 homarmaro□+2 hardeso di homarmaro",
  "item.minecraft.diamond_boots": "boti diamanta□□when on feet:□+3 homarmaro□+2 hardeso di homarmaro",
  "item.minecraft.golden_helmet": "helmo ora□□when on head:□+2 homarmaro",
  "item.minecraft.golden_chestplate": "torokuraso ora□□when on body:□+5 homarmaro",
  "item.minecraft.golden_leggings": "pantaloni ora□□when on legs:□+3 homarmaro",
  "item.minecraft.golden_boots": "boti ora□□when on feet:□+1 homarmaro",
  "item.minecraft.netherite_helmet": "helmo netherita□□when on head:□+3 homarmaro□+3 hardeso di homarmaro□+1 rezisto a retrosalto",
  "item.minecraft.netherite_chestplate": "torokuraso netherita□□when on body:□+8 homarmaro□+3 hardeso di homarmaro□+1 rezisto a retrosalto",
  "item.minecraft.netherite_leggings": "pantaloni netherita□□when on legs:□+6 homarmaro□+3 hardeso di homarmaro□+1 rezisto a retrosalto",
  "item.minecraft.netherite_boots": "boti netherita□□when on feet:□+3 homarmaro□+3 hardeso di homarmaro□+1 rezisto a retrosalto",
  "item.minecraft.flint": "silexo",
  "item.minecraft.porkchop": "kruda porkokarno",
  "item.minecraft.cooked_porkchop": "koquita porkokarno",
  "item.minecraft.painting": "pikturo",
  "item.minecraft.golden_apple": "pomo ora",
  "item.minecraft.enchanted_golden_apple": "sorcita pomo ora",
  "block.minecraft.oak_sign": "signo querka",
  "block.minecraft.spruce_sign": "signo abieta",
  "block.minecraft.birch_sign": "signo birka",
  "block.minecraft.jungle_sign": "signo mahagoniera",
  "block.minecraft.acacia_sign": "signo akacia",
  "block.minecraft.dark_oak_sign": "signo obskurquerka",
  "block.minecraft.crimson_sign": "signo karmezina",
  "block.minecraft.warped_sign": "signo bizara",
  "item.minecraft.bucket": "sitelo",
  "item.minecraft.water_bucket": "sitelo di aquo",
  "item.minecraft.lava_bucket": "sitelo di lavao",
  "item.minecraft.minecart": "minvagono",
  "item.minecraft.saddle": "selo",
  "item.minecraft.redstone": "pulvero di redstoneo",
  "item.minecraft.snowball": "nivbulo",
  "item.minecraft.oak_boat": "batelo querka",
  "item.minecraft.leather": "ledro",
  "item.minecraft.milk_bucket": "sitelo di lakto",
  "item.minecraft.pufferfish_bucket": "sitelo di suflantofisho",
  "item.minecraft.salmon_bucket": "sitelo di salmono",
  "item.minecraft.cod_bucket": "sitelo di gado",
  "item.minecraft.tropical_fish_bucket": "sitelo di fishi tropikala",
  "item.minecraft.brick": "briko",
  "item.minecraft.clay_ball": "argilbulo",
  "block.minecraft.dried_kelp_block": "bloko di algo sika",
  "item.minecraft.paper": "papero",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "slambulo",
  "item.minecraft.chest_minecart": "minvagono kun kofro",
  "item.minecraft.furnace_minecart": "minvagono kun furnazo",
  "item.minecraft.egg": "ovo",
  "item.minecraft.compass": "busolo",
  "item.minecraft.fishing_rod": "peskobastono",
  "item.minecraft.clock": "horlojo",
  "item.minecraft.glowstone_dust": "lumpetra polvo",
  "item.minecraft.cod": "kruda gado",
  "item.minecraft.salmon": "kruda salmono",
  "item.minecraft.tropical_fish": "fisho tropikala",
  "item.minecraft.pufferfish": "suflantofisho",
  "item.minecraft.cooked_cod": "koquita gado",
  "item.minecraft.cooked_salmon": "koquita salmono",
  "item.minecraft.ink_sac": "inksako",
  "item.minecraft.red_dye": "reda tinto",
  "item.minecraft.green_dye": "verda tinto",
  "item.minecraft.cocoa_beans": "kakafabi",
  "item.minecraft.lapis_lazuli": "lapislazulo",
  "item.minecraft.purple_dye": "purpura tinto",
  "item.minecraft.cyan_dye": "cyana tinto",
  "item.minecraft.light_gray_dye": "klargriza tinto",
  "item.minecraft.gray_dye": "griza tinto",
  "item.minecraft.pink_dye": "rozea tinto",
  "item.minecraft.lime_dye": "klarverda tinto",
  "item.minecraft.yellow_dye": "flava tinto",
  "item.minecraft.light_blue_dye": "cielblua tinto",
  "item.minecraft.magenta_dye": "magenta tinto",
  "item.minecraft.orange_dye": "oranjea tinto",
  "item.minecraft.bone_meal": "polvo di osto",
  "item.minecraft.blue_dye": "blua tinto",
  "item.minecraft.brown_dye": "bruna tinto",
  "item.minecraft.black_dye": "nigra tinto",
  "item.minecraft.white_dye": "blanka tinto",
  "item.minecraft.bone": "osto",
  "item.minecraft.sugar": "sukro",
  "block.minecraft.cake": "kuko",
  "block.minecraft.white_bed": "blanka lito",
  "block.minecraft.orange_bed": "oranjea lito",
  "block.minecraft.magenta_bed": "magenta lito",
  "block.minecraft.light_blue_bed": "cielblue lito",
  "block.minecraft.yellow_bed": "flava lito",
  "block.minecraft.lime_bed": "klarverda lito",
  "block.minecraft.pink_bed": "rozea lito",
  "block.minecraft.gray_bed": "griza lito",
  "block.minecraft.light_gray_bed": "klargriza lito",
  "block.minecraft.cyan_bed": "cyana lito",
  "block.minecraft.purple_bed": "purpura lito",
  "block.minecraft.blue_bed": "blua lito",
  "block.minecraft.brown_bed": "bruna lito",
  "block.minecraft.green_bed": "verda lito",
  "block.minecraft.red_bed": "reda lito",
  "block.minecraft.black_bed": "nigra lito",
  "item.minecraft.cookie": "bisquito",
  "item.minecraft.filled_map": "mapo□#0",
  "item.minecraft.shears": "cizego",
  "item.minecraft.melon_slice": "loncho di melono",
  "item.minecraft.dried_kelp": "kelpo sikigita",
  "item.minecraft.pumpkin_seeds": "semini di kukurbito",
  "item.minecraft.melon_seeds": "semini di melono",
  "item.minecraft.beef": "kruda bovokarno",
  "item.minecraft.cooked_beef": "bifsteko",
  "item.minecraft.chicken": "kruda hanokarno",
  "item.minecraft.cooked_chicken": "koquita hanokarno",
  "item.minecraft.rotten_flesh": "karno putrinta",
  "item.minecraft.ender_pearl": "enderperlo",
  "item.minecraft.blaze_rod": "bastono di blazo",
  "item.minecraft.ghast_tear": "lakrimo di ghasto",
  "item.minecraft.gold_nugget": "pepito ora",
  "item.minecraft.nether_wart": "netherveruko",
  "item.minecraft.potion": "pociono nefabrikebla□nula efekti",
  "item.minecraft.glass_bottle": "vitra botelo",
  "item.minecraft.spider_eye": "okulo di araneo",
  "item.minecraft.fermented_spider_eye": "okulo di araneo fermentacita",
  "item.minecraft.blaze_powder": "pulvero di blazo",
  "item.minecraft.magma_cream": "kremo di magmo",
  "block.minecraft.brewing_stand": "brasostativo",
  "block.minecraft.cauldron": "kaldrono",
  "item.minecraft.ender_eye": "enderokulo",
  "item.minecraft.glistering_melon_slice": "loncho di melono brilanta",
  "item.minecraft.bat_spawn_egg": "kreurovo di vespertilio",
  "item.minecraft.bee_spawn_egg": "frayifanto-ovo di abelo",
  "item.minecraft.blaze_spawn_egg": "kreurovo di blazo",
  "item.minecraft.cat_spawn_egg": "kreurovo di kato",
  "item.minecraft.cave_spider_spawn_egg": "kreurovo di kavernaraneo",
  "item.minecraft.chicken_spawn_egg": "kreurovo di hano",
  "item.minecraft.cod_spawn_egg": "kreurovo di gado",
  "item.minecraft.cow_spawn_egg": "kreurovo di bovo",
  "item.minecraft.creeper_spawn_egg": "kreurovo di creepero",
  "item.minecraft.dolphin_spawn_egg": "kreurovo di delfino",
  "item.minecraft.donkey_spawn_egg": "kreurovo di asno",
  "item.minecraft.drowned_spawn_egg": "kreurovo di dronito",
  "item.minecraft.elder_guardian_spawn_egg": "kreurovo di seniora guardero",
  "item.minecraft.enderman_spawn_egg": "kreurovo di endermano",
  "item.minecraft.endermite_spawn_egg": "kreurovo di endermito",
  "item.minecraft.evoker_spawn_egg": "kreurovo di evokanto",
  "item.minecraft.fox_spawn_egg": "kreurovo di foxo",
  "item.minecraft.ghast_spawn_egg": "kreurovo di ghasto",
  "item.minecraft.guardian_spawn_egg": "kreurovo di guardero",
  "item.minecraft.hoglin_spawn_egg": "kreurovo di hoglino",
  "item.minecraft.horse_spawn_egg": "kreurovo di kavalo",
  "item.minecraft.husk_spawn_egg": "kreurovo di husko",
  "item.minecraft.llama_spawn_egg": "kreurovo di lamao",
  "item.minecraft.magma_cube_spawn_egg": "kreurovo di magmakubo",
  "item.minecraft.mooshroom_spawn_egg": "kreurovo di mooshroomo",
  "item.minecraft.mule_spawn_egg": "kreurovo di mulo",
  "item.minecraft.ocelot_spawn_egg": "kreurovo di oceloto",
  "item.minecraft.panda_spawn_egg": "kreurovo di pando",
  "item.minecraft.parrot_spawn_egg": "kreurovo di papagayo",
  "item.minecraft.phantom_spawn_egg": "kreurovo di fantomo",
  "item.minecraft.pig_spawn_egg": "kreurovo di porko",
  "item.minecraft.piglin_spawn_egg": "kreurovo di piglino",
  "item.minecraft.pillager_spawn_egg": "kreurovo di spoilanto",
  "item.minecraft.polar_bear_spawn_egg": "kreurovo di urso blanka",
  "item.minecraft.pufferfish_spawn_egg": "frayifanto-ovo di suflantofisho",
  "item.minecraft.rabbit_spawn_egg": "kreurovo di kuniklo",
  "item.minecraft.ravager_spawn_egg": "kreurovo di devastanto",
  "item.minecraft.salmon_spawn_egg": "kreurovo di salmono",
  "item.minecraft.sheep_spawn_egg": "kreurovo di mutono",
  "item.minecraft.shulker_spawn_egg": "kreurovo di shulkero",
  "item.minecraft.silverfish_spawn_egg": "kreurovo di argentafisho",
  "item.minecraft.skeleton_spawn_egg": "kreurovo di skeleto",
  "item.minecraft.skeleton_horse_spawn_egg": "kreurovo di skeleta kavalo",
  "item.minecraft.slime_spawn_egg": "kreurovo di slamo",
  "item.minecraft.spider_spawn_egg": "kreurovo di araneo",
  "item.minecraft.squid_spawn_egg": "kreurovo di kalmaro",
  "item.minecraft.stray_spawn_egg": "kreurovo di vaganto",
  "item.minecraft.strider_spawn_egg": "kreurovo di pazeganto",
  "item.minecraft.trader_llama_spawn_egg": "kreurovo di lamao komercanta",
  "item.minecraft.tropical_fish_spawn_egg": "kreurovo di fisho tropikala",
  "item.minecraft.turtle_spawn_egg": "kreurovo di tortugo",
  "item.minecraft.vex_spawn_egg": "kreurovo di vexo",
  "item.minecraft.villager_spawn_egg": "kreurovo di vilajano",
  "item.minecraft.vindicator_spawn_egg": "kreurovo di vindikatoro",
  "item.minecraft.wandering_trader_spawn_egg": "kreurovo vaganta komercanto",
  "item.minecraft.witch_spawn_egg": "kreurovo di sorcino",
  "item.minecraft.wither_skeleton_spawn_egg": "kreurovo di witherskeleto",
  "item.minecraft.wolf_spawn_egg": "kreurovo di volfo",
  "item.minecraft.zoglin_spawn_egg": "zoglin spawn egg",
  "item.minecraft.zombie_spawn_egg": "kreurovo di zombio",
  "item.minecraft.zombie_horse_spawn_egg": "kreurovo di zombia kavalo",
  "item.minecraft.zombie_villager_spawn_egg": "kreurovo di zombia vilajano",
  "item.minecraft.zombified_piglin_spawn_egg": "kreurovo di piglino zombigita",
  "item.minecraft.experience_bottle": "botelo di sorco",
  "item.minecraft.fire_charge": "fairbulo",
  "item.minecraft.writable_book": "libro e plumo",
  "item.minecraft.written_book": "libro skribita",
  "item.minecraft.emerald": "smeraldo",
  "item.minecraft.item_frame": "kadro",
  "block.minecraft.flower_pot": "florpoto",
  "item.minecraft.carrot": "karoto",
  "item.minecraft.potato": "potato",
  "item.minecraft.baked_potato": "potato bakita",
  "item.minecraft.poisonous_potato": "potato toxika",
  "item.minecraft.map": "mapo vakua",
  "item.minecraft.golden_carrot": "karoto ora",
  "block.minecraft.skeleton_skull": "kranio di skeleto",
  "block.minecraft.wither_skeleton_skull": "kranio di witherskeleto",
  "block.minecraft.player_head": "kapo di ludanto",
  "block.minecraft.zombie_head": "kapo di zombio",
  "block.minecraft.creeper_head": "kapo di creepero",
  "block.minecraft.dragon_head": "kapo di drako",
  "item.minecraft.carrot_on_a_stick": "karoto sur bastono",
  "item.minecraft.warped_fungus_on_a_stick": "fungo bizara sur bastono",
  "item.minecraft.nether_star": "stelo di nether",
  "item.minecraft.pumpkin_pie": "torto di kukurbito",
  "item.minecraft.firework_rocket": "fuzeo di pirotekno",
  "item.minecraft.firework_star": "stelo di pirotekno",
  "item.minecraft.enchanted_book": "libro sorcita",
  "item.minecraft.nether_brick": "netherbriko",
  "item.minecraft.quartz": "quarco di nether",
  "item.minecraft.tnt_minecart": "minvagono kun tnt",
  "item.minecraft.hopper_minecart": "minvagono kun funelego",
  "item.minecraft.prismarine_shard": "ruptopeco di prismarino",
  "item.minecraft.prismarine_crystals": "kristali di prismarino",
  "item.minecraft.rabbit": "kruda kuniklokarno",
  "item.minecraft.cooked_rabbit": "koquita kuniklokarno",
  "item.minecraft.rabbit_stew": "kunikloraguto",
  "item.minecraft.rabbit_foot": "pedo di kuniklo",
  "item.minecraft.rabbit_hide": "felo di kuniklo",
  "item.minecraft.armor_stand": "vestiero",
  "item.minecraft.iron_horse_armor": "kavalkuraso fera",
  "item.minecraft.golden_horse_armor": "kavalkuraso ora",
  "item.minecraft.diamond_horse_armor": "kavalkuraso diamanta",
  "item.minecraft.leather_horse_armor": "kavalkuraso ledra",
  "item.minecraft.lead": "lazo",
  "item.minecraft.name_tag": "nometiketo",
  "item.minecraft.command_block_minecart": "minvagono kun bloko di komandi",
  "item.minecraft.mutton": "kruda mutonkarno",
  "item.minecraft.cooked_mutton": "koquita mutonkarno",
  "block.minecraft.white_banner": "blanka banero",
  "block.minecraft.orange_banner": "oranjea banero",
  "block.minecraft.magenta_banner": "magenta banero",
  "block.minecraft.light_blue_banner": "cielblua banero",
  "block.minecraft.yellow_banner": "flava banero",
  "block.minecraft.lime_banner": "klarverda banero",
  "block.minecraft.pink_banner": "rozea banero",
  "block.minecraft.gray_banner": "griza banero",
  "block.minecraft.light_gray_banner": "klargriza banero",
  "block.minecraft.cyan_banner": "cyana banero",
  "block.minecraft.purple_banner": "purpura banero",
  "block.minecraft.blue_banner": "blua banero",
  "block.minecraft.brown_banner": "bruna banero",
  "block.minecraft.green_banner": "verda banero",
  "block.minecraft.red_banner": "reda banero",
  "block.minecraft.black_banner": "nigra banero",
  "item.minecraft.end_crystal": "kristalo di end",
  "item.minecraft.chorus_fruit": "chorusfrukto",
  "item.minecraft.popped_chorus_fruit": "chorusfrukto krevita",
  "item.minecraft.beetroot": "betravo",
  "item.minecraft.beetroot_seeds": "semini di betravo",
  "item.minecraft.beetroot_soup": "betravoraguto",
  "item.minecraft.dragon_breath": "respirado di drako",
  "item.minecraft.splash_potion": "jetebla pociono nefabrikebla□nula efekti",
  "item.minecraft.spectral_arrow": "flecho spektrala",
  "item.minecraft.tipped_arrow": "pintata flecho nefabrikebla□nula efekti",
  "item.minecraft.lingering_potion": "duranta pociono nefabrikebla□nula efekti",
  "item.minecraft.shield": "shildo",
  "item.minecraft.elytra": "elitri",
  "item.minecraft.spruce_boat": "batelo abieta",
  "item.minecraft.birch_boat": "batelo birka",
  "item.minecraft.jungle_boat": "batelo mahagoniera",
  "item.minecraft.acacia_boat": "batelo akacia",
  "item.minecraft.dark_oak_boat": "batelo obskurquerka",
  "item.minecraft.totem_of_undying": "totemo di nemortivado",
  "item.minecraft.shulker_shell": "skalio di shulkero",
  "item.minecraft.iron_nugget": "pepiro fera",
  "item.minecraft.knowledge_book": "enciklopedio",
  "item.minecraft.debug_stick": "bastono di debugar",
  "item.minecraft.music_disc_13": "muzikdisko□c418 - 13",
  "item.minecraft.music_disc_cat": "muzikdisko□c418 - cat",
  "item.minecraft.music_disc_blocks": "muzikdisko□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muzikdisko□c418 - chirp",
  "item.minecraft.music_disc_far": "muzikdisko□c418 - far",
  "item.minecraft.music_disc_mall": "muzikdisko□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muzikdisko□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muzikdisko□c418 - stal",
  "item.minecraft.music_disc_strad": "muzikdisko□c418 - strad",
  "item.minecraft.music_disc_ward": "muzikdisko□c418 - ward",
  "item.minecraft.music_disc_11": "muzikdisko□c418 - 11",
  "item.minecraft.music_disc_wait": "muzikdisko□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muzikdisko□lena raine - pigstep",
  "item.minecraft.trident": "tridento□□when in main hand:□+8 domajo di atako□-2.9 rapideso di atako",
  "item.minecraft.phantom_membrane": "membrano di fantomo",
  "item.minecraft.nautilus_shell": "konko di nautilo",
  "item.minecraft.heart_of_the_sea": "kordio di la maro",
  "item.minecraft.crossbow": "arbalesto",
  "item.minecraft.suspicious_stew": "stufajo suspektema",
  "block.minecraft.loom": "texilo",
  "item.minecraft.flower_banner_pattern": "shablono di banero□floro",
  "item.minecraft.creeper_banner_pattern": "shablono di banero□creeperfacio",
  "item.minecraft.skull_banner_pattern": "shablono di banero□kranio",
  "item.minecraft.mojang_banner_pattern": "shablono di banero□simbolo",
  "item.minecraft.globe_banner_pattern": "shablono di banero□terkubo",
  "item.minecraft.piglin_banner_pattern": "shablono di banero□snout",
  "block.minecraft.composter": "dungilo",
  "block.minecraft.barrel": "barelo",
  "block.minecraft.smoker": "fumizilo",
  "block.minecraft.blast_furnace": "fornego",
  "block.minecraft.cartography_table": "tablo di kartografio",
  "block.minecraft.fletching_table": "tablo di flechado",
  "block.minecraft.grindstone": "grindstono",
  "block.minecraft.lectern": "libropupitro",
  "block.minecraft.smithing_table": "tablo di forjisto",
  "block.minecraft.stonecutter": "petrotaliilo",
  "block.minecraft.bell": "klosho",
  "block.minecraft.lantern": "lanterno",
  "block.minecraft.soul_lantern": "anmolanterno",
  "item.minecraft.sweet_berries": "dolcaberi",
  "block.minecraft.campfire": "kampfairo",
  "block.minecraft.soul_campfire": "soul campfire",
  "block.minecraft.shroomlight": "fungalumo",
  "item.minecraft.honeycomb": "vabo",
  "block.minecraft.bee_nest": "abelnesto",
  "block.minecraft.beehive": "abeluyo",
  "item.minecraft.honey_bottle": "botelo di mielo",
  "block.minecraft.honey_block": "bloko di mielo",
  "block.minecraft.honeycomb_block": "bloko di vabo",
  "block.minecraft.lodestone": "magnetstono",
  "block.minecraft.netherite_block": "bloko di netherito",
  "block.minecraft.ancient_debris": "resajo anciena",
  "block.minecraft.target": "pafskopo",
  "block.minecraft.crying_obsidian": "obsidiano ploranta",
  "block.minecraft.blackstone": "nigrapetro",
  "block.minecraft.blackstone_slab": "plako di nigrapetro",
  "block.minecraft.blackstone_stairs": "eskalero di nigrapetro",
  "block.minecraft.gilded_blackstone": "gilded blackstone",
  "block.minecraft.polished_blackstone": "polished blackstone",
  "block.minecraft.polished_blackstone_slab": "polished blackstone slab",
  "block.minecraft.polished_blackstone_stairs": "polished blackstone stairs",
  "block.minecraft.chiseled_polished_blackstone": "chiseled polished blackstone",
  "block.minecraft.polished_blackstone_bricks": "polished blackstone bricks",
  "block.minecraft.polished_blackstone_brick_slab": "polished blackstone brick slab",
  "block.minecraft.polished_blackstone_brick_stairs": "polished blackstone brick stairs",
  "block.minecraft.cracked_polished_blackstone_bricks": "cracked polished blackstone bricks",
  "block.minecraft.respawn_anchor": "regenitankro",
}
export const io_en = items; 
